import React, { useEffect, useMemo, useRef, useState } from 'react'

import BasicSlide from '../basic-slide/basic-slide'
import BannerShare from '../banner-share/banner-share'
import ColumnsSlide from '../columns-slide/columns-slide'
import DataSlide from '../data-slide/data-slide'
import BulletsSlide from '../bullets-slide/bullets-slide'
import VideoSlide from '../video-slide/video-slide'

import * as style from './slide-block.module.scss'

const SlideBlock = ({ slide, customIndex, i, anchor, papers = [] }) => {
  const [isVisible, setVisible] = useState(false)
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const ref = useRef()
  const refContainer = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVisible(true)
        } else {
          setVisible(false)
        }
      },
      {
        threshold: 0.2
      }
    )

    observer.observe(ref.current)

    return () => {
      observer.disconnect()
    }
  }, [])

  const canShare =
    typeof window !== 'undefined' && typeof navigator?.share === 'function'

  const handleOnShare = async (e) => {
    if (typeof window === 'undefined') return

    try {
      e.preventDefault()

      const URL = `${
        window.location?.protocol +
        '//' +
        window.location?.host +
        window.location?.pathname
      }?slide=${i}#${anchor}`

      if (canShare) {
        navigator.share({
          url: URL
        })

        return
      }

      if (navigator?.clipboard) {
        await navigator.clipboard.writeText(URL)

        setTooltipVisible(true)

        setTimeout(() => {
          setTooltipVisible(false)
        }, 2500)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const buttonLink = useMemo(() => {
    if (typeof window === 'undefined') return

    const contents = papers.map((content) => content.originalId ?? content.id)

    const currentPath = window.location.pathname

    let params = `${currentPath}?open-modal=true`

    if (contents?.length > 0) {
      params += `&content=${contents.join(',')}`
    }

    return params
  }, [papers])

  return (
    <>
      <div
        ref={ref}
        className={`keen-slider__slide number-slide${i} ${style.slideItem}`}
        style={{
          overflowY: 'auto'
        }}
      >
        <div ref={refContainer} className="container">
          {slide.__typename === 'DatoCmsBulletsSlide' && (
            <div className={`row ${style.slide}`}>
              <BulletsSlide slide={slide} customIndex={customIndex} />
            </div>
          )}
          {slide.__typename === 'DatoCmsBasicSlide' && (
            <div className={`row ${style.slide}`}>
              <BasicSlide slide={slide} customIndex={customIndex} />
            </div>
          )}
          {slide.__typename === 'DatoCmsColumnsSlide' && (
            <div className={`row ${style.slide}`}>
              <ColumnsSlide slide={slide} customIndex={customIndex} />
            </div>
          )}
          {slide.__typename === 'DatoCmsDataSlide' && (
            <div className={`row ${style.slide}`}>
              <DataSlide slide={slide} customIndex={customIndex} />
            </div>
          )}
          {slide.__typename === 'DatoCmsVideoSlide' && (
            <div className={`row ${style.slide}`}>
              <VideoSlide slide={slide} customIndex={customIndex} />
            </div>
          )}

          <BannerShare
            isVisible={isVisible}
            tooltipVisible={tooltipVisible}
            buttonLink={buttonLink}
            handleOnShare={handleOnShare}
            anchor={anchor}
            variant="static"
            slideIndex={i}
          />
        </div>
      </div>
      <BannerShare
        isVisible={isVisible}
        tooltipVisible={tooltipVisible}
        buttonLink={buttonLink}
        handleOnShare={handleOnShare}
        anchor={anchor}
        variant="fixed"
        slideIndex={i}
      />
    </>
  )
}

export default SlideBlock
